PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
templates = require 'views/internal/templates'
l = require 'lib/localize'

module.exports = class Confirm extends View

  constructor: ({ @model, text, html, @elem, @top, confirmText, confirmBtnClass, cancelText, @title, @template, @templateData, data, fxConfirm, fxCancel, @popOnClick, @popDepth, maxWidth }) ->
    @template ?= 'confirm'
    @confirm = @_handleClick(fxConfirm)
    @cancel = if fxCancel then @_handleClick(fxCancel) else ->
    @data = _.extend { text, html, confirmText, confirmBtnClass, cancelText }, (data ? {})
    @templateData ?= {}
    @maxWidth = maxWidth
    super

  # We don't want to evaluate a key that's
  # explicitly specified, because it might
  # require interpolation, or it might not
  # even exist. Look, these lines line up!
  lazyDefaults = (original, defaults) ->
    target = _.clone(original)
    for own key, valueFunction of defaults
      if key not of target
        target[key] = valueFunction()
    return target

  makeOpts = (key, oldOpts) ->
    opts = lazyDefaults oldOpts,
      title: -> l(['confirm', key, 'title'], oldOpts.templateData)
      # We are currently assuming that translations are safe HTML
      html: -> l(['confirm', key, 'text'], oldOpts.templateData)
      confirmText: -> l(['confirm', key, 'confirm'], oldOpts.templateData)

    if 'fxCancel' of opts && 'cancelText' not of opts
      opts.cancelText = l(['confirm', key, 'cancel'], oldOpts.templateData)

    return opts

  @toggle: (key, opts) ->
    if arguments.length == 1
      opts = key
    else
      opts = makeOpts(key, opts)

    PopOver.toggle
      elem: opts.elem
      top: opts.top
      alignRight: opts.alignRight
      view: @
      options: opts

  @pushView: (key, opts) ->
    if arguments.length == 1
      opts = key
    else
      opts = makeOpts(key, opts)

    PopOver.pushView
      view: @
      options: opts

  getViewTitle: -> @title

  events:
    'click .js-confirm': 'confirm'
    'click .js-cancel': 'cancel'

  render: ->
    @$el.html(
      templates.fill(
        @template,
        @data,
        {},
        { member: templates.member }
      )
    )
    setTimeout((e) =>
      @$el.find('.js-confirm').focus()
      0)
    @

  _handleClick: (fx) ->
    (e) =>
      Util.stop(e)

      if @popOnClick
        PopOver.popView(@popDepth)
      else
        PopOver.hide()

      fx?(e)
      @remove()
      return false



// WEBPACK FOOTER //
// ./app/scripts/views/lib/confirm.coffee